"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activateUser = exports.signUp = void 0;
var redux_saga_routines_1 = require("redux-saga-routines");
// creating routine
exports.signUp = (0, redux_saga_routines_1.createRoutine)('sign-up/SIGN_UP');
exports.activateUser = (0, redux_saga_routines_1.createRoutine)('sign-up/ACTIVATE_USER');
